(function () {
    'use strict';

    angular
        .module('app')
        .directive('docDashboard', docDashboard);

    docDashboard.$inject = ['$window', '$timeout'];

    function docDashboard($window, $timeout) {
        // Usage:
        //     <ddResize></ddResize>
        // Creates:
        // 
        var directive = {
            link: link,
            restrict: 'EA',
            scope: {
                onResize: "=?",
                accessor: "=",
            },
            controller: "docDashboard",
            controllerAs: "vm",
            templateUrl: "app/documentdashboard/templates/docdashboard.html"
        };
        return directive;

        function link(scope, element, attrs) {
            var update = false;
            var handlePosition = 0;
            var handle = angular.element("<div class='handle'></div>");
            element.prepend(handle);
            var el = angular.element(element);
            scope.hideContent = true;
            scope.opened = false;
            var wrapper = el.prev();
            handle[0].addEventListener('touchstart', down);
            handle[0].addEventListener('mousedown', down);
            el[0].draggable = false;
            handle.draggable = false;
            var offSet = 0;

            //handler for mouse/touch down event
            function down(event) {
                if (scope.opened) {
                    document.addEventListener('touchend', up);
                    document.addEventListener('mouseup', up);
                    handle.css("height", "1px");
                    handle.css("border", "1px dotted rgb(120,120,120)");
                    handle.css("background-color", "white");
                    //add 3 pixels to the bottom element to compensate for the loss of the handle
                    var topHeight = parseInt(element.css("height")) + 3;
                    element.css("height", topHeight + "px")
                    event.preventDefault();
                    document.addEventListener('mousemove', mouseMove);
                    document.addEventListener('touchmove', touchmove);
                }
            }

            //handler for mouse/touch up event
            function up(event) {
                handle.css("height", "4px");
                handle.css("border", "");
                handle.css("background-color", "rgb(240,240,240)");
                event.preventDefault();
                document.removeEventListener('mousemove', mouseMove);
                document.removeEventListener('touchmove', touchmove);
                if (update) {
                    var offSet = window.innerWidth > 767 ? 50 : 100;
                    scope.setSize(parseInt(element.parent().css('height'))-handlePosition+offSet);
                }
                handle.css('position', '');
                handle.css('top', '');
                update = false;
                document.removeEventListener('touchend', up);
                document.removeEventListener('mouseup', up);
            }

            //mousemove handler
            function mouseMove(event) {
                setHandlePosition(event.clientY);
            }

            //touch move handler for mobile devices
            function touchmove(e) {
                var touchobj = e.changedTouches[0];
                setHandlePosition(touchobj.clientY);

            }

            //sets the position of the handle to absolute and sets the position based on the given value
            function setHandlePosition(position) {
                //console.log("handlePos:", position, "parentHeight:", element.parent().css('height'));
                var parentHeight = angular.element(element.parent()).height();
                if (position > parentHeight / 2 && position < parentHeight - 30) {
                    handle.css('position', "fixed");
                    handle.css('top', position + "px");
                    handlePosition = position;
                    update = true;
                }
            }

            scope.open = function () {
                var parentHeight = angular.element(element.parent()).height();
                scope.setSize(parentHeight/2);
            }

            scope.close = function () {
                //scope.setSize(0);
                scope.onResize({ topHeight: el.prev().css('height'), bottomHeight: el.css("height") });
            }

            scope.setSize = function (size) {
                //set the top
                $timeout(function () {
                    element.css('flex', '0 0 ' + size + 'px');
                    scope.onResize({ topHeight: el.prev().css('height'), bottomHeight: el.css("height") });
                }, 100);

                scope.resized(parseInt(el.css("height")));

            }

            angular.element($window).bind('resize', function () {
                scope.triggerResize();
            });

            scope.triggerResize = function () {

                //header offset
                var offSet = 0;
                //bottom size, if it's closed set to 0
                var bottom = scope.opened ? parseInt(element.css('height')) : 0;
                //parent container size
                var main = parseInt(angular.element(el.parent()).height());
                var top = parseInt(element.prev().css('height'));
                
                if (bottom > 0) {
                    //figure out percentages
                    var area = main - offSet;
                    var topPercent = Math.round(top * 100 / area);
                    var bottomPercent = 100 - topPercent;
                    //console.log('-------------------------------------------------')
                    //console.log('Main', main);
                    //console.log('area', area);
                    //console.log('top', top);
                    //console.log('bottom', bottom);
                    //console.log('topPercent', topPercent);
                    //console.log('bottomPercent', bottomPercent);
                    var newTop = Math.round((area * 60) / 100);
                    var newBottom = area - newTop;

                    element.css('flex', '0 0 '+newBottom +'px');
                }

                //fire the onResize event
                scope.onResize({ topHeight: el.prev().css('height'), bottomHeight: el.css("height") });
                scope.resized(parseInt(el.css("height")));
            }

            //set the initial sizes
            //scope.close();

            var cachedSize = element.css('height');

            $timeout(function () {
                scope.onResize({ topHeight: el.prev().css('height'), bottomHeight: el.css("height") });
            }, 500);

        }


    }

})();